// extracted by mini-css-extract-plugin
module.exports = {"ActivityCard":"ActivityCard_ActivityCard__1OvxE","titulo":"ActivityCard_titulo__mBGxP","detalles":"ActivityCard_detalles__3xdwY"};